import React from 'react'
import { Button, Header } from 'semantic-ui-react'


import { useTranslation } from 'react-i18next'

import {
  FETCH_COLLAR_PLATES_INFO,
} from '../../../../../../redux/actions/actionTypes'
import createAction from '../../../../../../redux/actions/createAction'

import {
    HARDCODED_US_KEG_COLLAR_CONTACT,
} from '../../../../../../constants'
import ContactCardWithHardCodedContactInfo
    from '../../../../../../common-components/ContactCardWithHardCodedContactInfo'


export default ({
  customerId,
  operatingContractBrewerCustomerId,
  dispatch,
}) => {
  const { t: translate } = useTranslation('common')
  return (
    <div>
      <Header as="h3" inverted color="red">
        {translate('You have no collar plates!')}
      </Header>
      <p>{translate("Looks like you have no active collar plates on file with us. Contact us to register a collar plate, then you'll be able to use this feature.")}</p>
      <ContactCardWithHardCodedContactInfo
        {...HARDCODED_US_KEG_COLLAR_CONTACT}
      />
      <Button
        color="blue"
        content={translate('Refresh Collar Plates List')}
        onClick={() => dispatch(createAction(
          FETCH_COLLAR_PLATES_INFO,
          {
            customerId,
            operatingContractBrewerCustomerId,
          },
        ))}
      />
    </div>
  )
}
